import { useLayoutEffect, useState } from 'react';
import { Platform } from 'react-native';

export default function useChatScrollbarInset(getScrollElement, enabled, conversationId, ready) {
  const active = Platform.OS === 'web' && enabled;
  const [inset, setInset] = useState(16);
  useLayoutEffect(() => {
    if (!active) return undefined;
    const node = getScrollElement();
    if (!node) return undefined;
    // Overlay scrollbars report zero layout width; still leave their drag
    // target clear. Honor wider classic scrollbars/accessibility settings.
    const measure = () => setInset(Math.max(16, node.offsetWidth - node.clientWidth || 0));
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(node);
    window.addEventListener('resize', measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [active, getScrollElement, conversationId, ready]);
  return active ? inset : 0;
}
